var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWavyLineSvg = function SvgWavyLineSvg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 214,
    height: 1020,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B1D0FF",
    strokeDasharray: "6 6",
    d: "M130.613 3.306C73.113 2.304 4.13 45.304 10.113 158.805c4.737 89.857 68.344 119.497 72 262.497 2.992 117-72.5 157.896-72.5 241 0 160.001 129.598 209.5 164.5 305"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B1D0FF",
    strokeDasharray: "6 6",
    d: "M149.615 1.307c-59 0-146.425 63.954-141.5 177.505 3.898 89.897 93.909 144.623 80 286.993-8.5 87-69.726 136.903-70.5 220.004-1.492 159.993 151.989 237.678 186 333.501"
  })));
};
export default SvgWavyLineSvg;